var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-wrp",class:_vm.className},[_c('div',{staticClass:"tip-text"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"tip-exit",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }